import styled from '@emotion/styled'
import { Container, Grid, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Heading, P, SectionHeading, SectionSmallHeading, SectionSubHeading, SectionWrapper } from '../../Styles/style'
import copy from "../../../assets/images/copy.png"
import tokoimg from "../../../assets/images/tokoimg.png"

import DoneAllIcon from '@mui/icons-material/DoneAll';
const DIv = styled.div`
  position: relative;
`
const Value = styled.p`
color: #fff;
position: absolute;
    /* top: 29px; */
    left: 70px;
    @media screen and (max-width:1199px){
        bottom: 29px;
        left: 70px;
        font-size: 12px;
    }
`
const Grids = styled(Grid)`
display: flex;
justify-content: center;

text-align: -webkit-center;
text-align: -moz-center;
`

const BuyNow = styled.a`
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textTertiary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
padding: 12px 20px;
border-radius: 5px;
margin-right: 15px;
display: flex;
align-items: center;

`
const Bdr = styled.div`
border-radius:8px;
padding:10px 20px 50px;
background-color: ${(props) => (props.bgColor ? props.bgColor : "#0f0f3658")};
`;
const Ca = styled.div`
border-radius:8px;
border:1px solid #fff;
padding:0px 20px;
display:flex;
justify-content:space-between;
align-items:center;
background-color: ${(props) => (props.bgColor ? props.bgColor : "#0f0f3658")};
@media screen and (max-width: 450px) {
    /* display:grid; */
 }
 `;


const Textarea = styled.textarea`
 font-size: 17px;
 resize: none;
font-family: "P-SB";
 overflow: hidden;
 color:#fff;
 border: none;
 width:530px;
 /* width:320px; */
 background: transparent;
 text-align: -webkit-center;
 text-align: -moz-center;
 outline: none;

 `;
const ContractAdd = styled.span`
 word-break: keep-all;
border:1px solid #fff;
 width:100%;
 max-width:80%;
 border-radius: 20px;;
 display: flex;
 justify-content: space-between;
 align-items: flex-start;
 padding:10px 30px;
 height:60px;
 @media screen and (max-width: 1400px) {
   height:80px;
 }
 @media screen and (max-width: 600px) {
   height:90px;
   max-width:100%;
 }
 `;
const S6_Tokenomics = () => {

    const [copySuccess, setCopySuccess] = useState("");
    const textAreaRef = useRef(null);


    function copyToClipboard(e) {
        textAreaRef.current.select();
        document.execCommand("copy");
        // This is just personal preference.
        // I prefer to not show the whole text area selected.
        e.target.focus();
        setCopySuccess(<DoneAllIcon style={{ fill: "#fff" }} />);
    }
    useEffect(() => {
        setTimeout(() => {
            setCopySuccess('')
        }, 2000)
    }, [copySuccess]);

    const SectionMainWrapper = styled.div`
/* min-height: 100vh; */
/* align-items: center;
place-items: flex-end;
display: flex; */
background-image: url(${tokoimg});
background-size: contain;
  background-color: ${(props) => (props.bgColor ? props.bgColor : "")};
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "center")};
  
border-top:${(props) => (props.bt ? props.bt : "")};
  @media screen and (max-width: 799px) {
    padding: ${(props) => (props.p799 ? props.p799 : "30px 0")};
  }
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.p599 ? props.p599 : "30px 0")};
  }
`;
    const Buy = styled.div`
font-size: 40px;
color: ${(props) => (props.bgColor ? props.bgColor : "#00FF88")};
font-family: P-B;
text-transform: uppercase;
text-shadow:0px 7px 10px ${(props) => (props.bColor ? props.bgColor : " #00ff8876")};
padding:0 20px;
@media screen and (max-width:349px){
    
font-size: 30px;
}
`
    const theme = useTheme()
    return (
        <div>
            <SectionMainWrapper p="4rem 0" id="tokenomics" align="center">
                <Container maxWidth="xl">
                    <SectionSubHeading align="center" p="20px 0 0" m="0" bg="linear-gradient(90deg, #FF0000 46%, #E619E6 50%, #0080FF 55%, #00EAFF 100%)">Tokenomics</SectionSubHeading>
                    <Heading align="center" p="10PX 0 0" m="0" tt="none" >55,000,000 RHP</Heading>


                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Buy>Buy</Buy>
                        <Heading fs349="30px">1%/2%</Heading>
                        <Buy bgColor="#FF0002" bColor="#ff000068">sell</Buy>
                    </div>
                    <Grids container justifyContent="center" >

                    <Grid item xs={12} md={6} xl={6} >
                              <Heading align="center" fs="20px" p="20PX 0" m="0" tt="none" >CONTRACT ADDRESS</Heading>
                         <ContractAdd>
                                <Textarea ref={textAreaRef} value="0xa0B4a6BBf908D8cd3d3b86Df6C1708C4aAE0c74d" />
                                <img
                                    onClick={copyToClipboard}
                                    style={{ cursor: "pointer" }}
                                    src={copy}
                                />
                                {copySuccess}
                            </ContractAdd>

                    </Grid>

                            </Grids>
                </Container>
            </SectionMainWrapper>
        </div>
    )
}

export default S6_Tokenomics